/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetUnmatchedChainsPreviewQueryResponse,
  GetUnmatchedChainsPreview422,
} from '../types/GetUnmatchedChainsPreview'

function getGetUnmatchedChainsPreviewUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/importengine/previews/v2/unmatched-chains/` as const,
  }
  return res
}

/**
 * @summary Build (or fetch) the unmatched-chains preview for the company
 * {@link /api/v1/importengine/previews/v2/unmatched-chains/}
 */
export async function getUnmatchedChainsPreview(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetUnmatchedChainsPreviewQueryResponse,
    ResponseErrorConfig<GetUnmatchedChainsPreview422>,
    unknown
  >({
    method: 'GET',
    url: getGetUnmatchedChainsPreviewUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
